<template>
  <!-- <PageLoader
    v-if="!loadingFinished"
    :width="'200px'"
    :height="'250px'"
    :text="'Fetching Data'"
  /> -->
  <!-- <template v-else> -->
  <div class="controls">
    <div class="controls__start">
     
     
      <ToggleButton
        v-if="parkedDatasetCount && parkedDatasetCount > 0"
        v-model="showParked"
        class="ms-2 parked-toggle-btn"
        :icon="'visibility'"
        :iconActive="'visibility_off'"
      >
        {{ showParked ? 'Hide Parked Datasets' : `Show Parked (${parkedDatasetCount})` }}
      </ToggleButton>
    </div>

    <HelpTip style="margin-left: 20px;">
      Dataset list shows all datasets that belong to this project that you have access to. Click on the Gallery icon to open dataset gallery.
      Datasets can be parked if not used for extensive period. Parked dataset are hidden by default.
    </HelpTip>

    <HelpTip v-if="isReadOnly || isPublic" help_style="alert">
      <div v-if="isReadOnly">This Project is read only. You cannot edit dataset or create annotations.  </div>
      <div v-if="isPublic">This Project is Public. Any dataset under this project will be visible publicly.  </div>
    </HelpTip>

    <div class="controls__end">
      <div class="controls__actions">
        <!-- <DatasetManagerFilters
          v-model="datasetFilters"
        /> -->
        <ActionsButton
          label="Actions"
          :actions="datasetActions"
          buttonStyle="chevron"
          :showCount="true"
          :selectedCount="selectedCount"
          @action-clicked="handleDatasetActionClick"
        />
      </div>
    </div>
  </div>
  <div v-if="isFetching" id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div>

  <div v-else-if="!isFetching && notEmpty" class="manager-card-container scrollbar">
    <DatasetCard
      v-for="d in internalDatasetList"
      :key="d.id"
      :annotationSets="d.annotation_sets"
      :labels="d.labels"
      :dataset="d"
      :selected="selectedDatasets[d.id] || false"
      :permissions="permissions"
      class="list-card"
      @update:labels="(labels) => setDatasetLabels(d, labels)"
      @copy-annset="handleOpenAnnotationCopy(set, d)"
      @delete-dataset="openConfirmDeleteDatasetModal(d)"
      @copy-dataset="handleCopyDatasetClicked(d)"
      @clicked="handleSelectDataset(d)"
      @create-annset="handleCreateAnnotationSet(d)"
      @delete-annset="(params) => openConfirmDeleteAnnsetModal(params)"
      @create-label="handleCreateLabel(d)"
      @label-created="handleUpdateLabel(d)"
      @update-label="handleUpdateLabel(d)"
      @deleted-label="(label) => handleLabelDeletedEvent(label, d)"
      @open-dataset-access-management="handleOpenDatasetAccessManagement"
      @refresh="refreshDatasetCard(d)"
      @open-import="openImportModal(d)"
      @open-export="openExportModal(d)"
      @open-upload="openUploadModal(d)"
      @edit-dataset="openUpdateModal(d)"
      @freeze-dataset="(isFrozen) => handleToggleFreeze(d, isFrozen)"
      @import-annset="openImportAnnsetModal(d)"
      @create-groups="openCreateGroupsModal(d)"
      @delete-group="(group) => openConfirmDeleteGroupModal(group)"
      @to-gallery="handleNavigateToGallery(d)"
      @generate-token="handleOpenGenerateTokenModal(d)"
      @open-conf-matrix="(set) => handleOpenConfMatrix(d, set)"
      @open-description="(set) => handleUpdateAnnotationSet(d, set)"
      @add-snapshot="handleOpenAddSnapshotModal(d)"
      @dismiss-error="dismissError(d)"
      @generate-hash="(set) => generateHash(d, set)"
      @dataset-selected="handleDatasetSelected"
    />
  </div>
  <div
    v-else
    class="empty-state"
  >
    <EmptyState
      :title="'No datasets found for this project'"
      :subtitle="'To add a new dataset, click on NEW DATASET'"
    />
  </div>
  <DatasetCreateModal
    ref="createDatasetModal"
    @create-dataset="createDataset"
  />
  <DatasetUpdateModal
    ref="updateDatasetModal"
    :dataset="modalDataset"
    @edit-dataset="(params) => updateDataset(params, modalDataset)"
  />
  <DatasetCopyModal
    v-if="showCopyModal"
    ref="copyDatasetModal"
    v-model:show="showCopyModal"
    :datasets="internalDatasetList"
    :source="modalDataset"
    @copy-complete="(destDatasetID) => refreshDatasetCard(getDatasetWithID(destDatasetID))"
    @closed="modalDataset = null"
    @copy-in-progress="handleCopyInProgress"
    @confirm-copy="confirmCopy"
  />
  <ConfirmModal
    ref="confirmModal"
    :messageHeader="confirmMessageHeader"
    :message="confirmMessage"
    :note="confirmNote"
    :buttonClass="buttonClass"
    :buttonText="buttonText"
    @confirmed="confirmFunction"
  />
  <AnnSetCopyModal
    ref="copyAnnSetModal"
    :datasets="internalDatasetList"
    :sourceDataset="copyAnnotationSetDataset"
    @clear-copy="clearCopyAnnset"
    @copy-complete="$emit('copy-complete')"
  />
  <CreateAnnotationSetModal
    ref="createAnnotationSetModal"
    :datasetId="modalDataset?.id"
    @annotation-set-created="handleAnnotationSetCreatedEvent(modalDataset)"
    @annotation-set-created-error="handleAnnotationSetCreatedErrorEvent"
  />
  <UpdateAnnotationSetModal
    ref="updateAnnotationSetModal"
    :annotationSet="modalAnnotationSet"
    @annotation-set-updated="handleAnnotationSetUpdatedEvent(modalDataset)"
  />
  <CreateLabelsModal
    ref="createLabelsModal"
    :datasetId="modalDataset?.id"
    @label-created="handleLabelCreatedEvent(modalDataset)"
  />
  <ManageDatasetAccess
    ref="manageDatasetAccessModal"
    :modalDataset="modalDataset"
    @refresh-datasets="handleAccessUpdated(modalDataset)"
  />
  <DatasetExportModal
    ref="datasetExportModal"
    :datasets="internalDatasetList"
    :exportDataset="impexDataset"
    @export-started="(data) => handleStartExport(impexDataset,data)"
  />
  <UploadImagesModal
    v-if="showUploadModal"
    ref="uploadImagesModal"
    v-model:show="showUploadModal"
    :datasetID="modalDataset ? modalDataset.id : null"
    :annotationSets="modalDataset ? modalDataset.annotation_sets : null"
    @refresh="refreshDatasetCard(modalDataset)"
    @upload-error="handleUploadError"
    @confirm-duplicate-upload="confirmDuplicateUpload"
  />
  <GenerateTokenModal
    ref="generateTokenModal"
    :modalDataset="modalDataset"
  />
  <CreateGroupsModal
    ref="createGroupsModal"
    :dataset="modalDataset"
    @created-groups="refreshDatasetCard(modalDataset)"
  />
  <ConfusionMatrixModal
    ref="confusionMatrixModal"
  />
  <SnapshotAddModal
    ref="addSnapshotModal"
    :mode="'add'"
    :inputDataset="modalDataset"
    :inputProject="currentProject"
    :projects="projectList"
    @add-snapshot="refreshDatasetCard(modalDataset)"
  />
  <DatasetMoveDialog
    ref="datasetMoveDialog"
    :selectedDatasets="selectedDatasetsObjects"
    :currentProjectId="currentProject?.id"
    @move-datasets="handleDatasetsMoved"
    @cancelled="showActionsDropdown = false"
  />
  <DatasetDeleteDialog
    ref="datasetDeleteDialog"
    :selectedDatasets="selectedDatasetsObjects"
    :currentProjectId="currentProject?.id"
    @delete-datasets="handleDatasetsDeleted"
    @cancelled="showActionsDropdown = false"
  />
</template>

<script>
import ManageDatasetAccess from '@/components/DatasetComponent/DatasetManagement/ManageDatasetAccess.vue';
import CreateLabelsModal from '@/components/DatasetComponent/DatasetManagement/CreateLabelsModal.vue';
import DatasetCard from "@/components/DatasetComponent/DatasetManagement/DatasetCard.vue";
import DatasetCopyModal from "@/components/DatasetComponent/DatasetManagement/DatasetCopyModal.vue";
import DatasetCreateModal from "@/components/DatasetComponent/DatasetManagement/DatasetCreateModal.vue";
import DatasetUpdateModal from "@/components/DatasetComponent/DatasetManagement/DatasetUpdateModal.vue";
import AnnSetCopyModal from '@/components/DatasetComponent/DatasetManagement/AnnSetCopyModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import CreateAnnotationSetModal from '@/components/DatasetComponent/DatasetManagement/CreateAnnotationSetModal.vue';
import UpdateAnnotationSetModal from '@/components/DatasetComponent/DatasetManagement/UpdateAnnotationSetModal.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import DatasetExportModal from '@/components/DatasetComponent/DatasetManagement/DatasetExportModal.vue';
import UploadImagesModal from '@/components/DatasetComponent/UploadImagesModal.vue';
import CreateGroupsModal from '@/components/DatasetComponent/DatasetManagement/CreateGroupsModal.vue';
import GenerateTokenModal from '@/components/DatasetComponent/DatasetManagement/GenerateAPITokenModal.vue';
import ConfusionMatrixModal from '@/components/DatasetComponent/DatasetManagement/ConfusionMatrixModal.vue';
import SnapshotAddModal from '@/components/Snapshots/SnapshotAddModal.vue';
import DatasetMoveDialog from '@/components/DatasetComponent/DatasetManagement/DatasetMoveDialog.vue';
import DatasetDeleteDialog from '@/components/DatasetComponent/DatasetManagement/DatasetDeleteDialog.vue';
import EmptyState from '@/components/EmptyState.vue';
import ActionsButton from '@/components/ActionsButton.vue';
import { toRaw } from 'vue';
import DatasetManagerFilters from '@/components/DatasetComponent/DatasetManagement/DatasetManagerFilters.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import { useToast } from 'vue-toast-notification';
import useTaskModal from '@/composables/useTaskModal.js';
import { event } from 'vue-gtag';
import HelpTip from '../../HelpTip.vue';
import { goto_dataset_gallery } from '@/assets/js/links.js';

import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'DatasetManagement',
  components: {
    DatasetCard,
    DatasetCopyModal,
    DatasetCreateModal,
    ConfirmModal,
    AnnSetCopyModal,
    CreateAnnotationSetModal,
    UpdateAnnotationSetModal,
    CreateLabelsModal,
    ManageDatasetAccess,
    DatasetExportModal,
    DatasetUpdateModal,
    UploadImagesModal,
    CreateGroupsModal,
    GenerateTokenModal,
    ConfusionMatrixModal,
    SnapshotAddModal,
    DatasetManagerFilters,
    ToggleButton,
    HelpTip,
    EmptyState,
    DatasetMoveDialog,
    DatasetDeleteDialog,
    ActionsButton,
  },
  emits: [
    'create-dataset', 'copy-complete', 'delete-dataset', 'select-dataset', 'update:datasetList', 'edit-dataset',
  ],
  setup() {
    const {
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    } = useTaskModal();

    return {
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    };
  },
  data() {
    return {
      dataConnect: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      loadingFinished: true,
      toDelete: null,
      copyAnnotationSet: null,
      copyAnnotationSetDataset: null,
      confirmMessage: null,
      confirmNote: null,
      confirmMessageHeader: null,
      buttonClass: "button-delete",
      buttonText: "",
      modalAnnotationSet: null,
      modalDataset: null,
      isImport: false,
      isUpdate: false,
      impexDataset: null,
      confirmFunction: null,
      datasetAccessList: [],
      showUploadModal: false,
      showCopyModal: false,
      showSnapshotsModal: false,
      controllers: [],
      isFetching: false,
      isFetchingParkedDatasetCount: false,
      interval: null,
      // datasetFilters: [],
      parkedDatasetCount: null,
      // showParked: false,
      isReadOnly: false,
      permissions: null,
      selectedDatasets: {},
      datasetActions: [
        { icon: 'add', label: 'New', eventKey: 'new', tooltip: 'Create New Dataset' },
        { icon: 'folder2', label: 'Move to Project', eventKey: 'move', tooltip: 'Move selected datasets to another project' },
        { icon: 'parking', label: 'Park', eventKey: 'park', tooltip: 'Park datasets to hide temporarily' },
        { icon: 'play', label: 'Unpark', eventKey: 'unpark', tooltip: 'Reactivate parked datasets' },
        { icon: 'delete', label: 'Delete', eventKey: 'delete', isAlert: true, tooltip: 'Delete selected datasets' },
      ],
    };
  },
  computed: {
    modalDatasetId() {
      if (this.modalDataset) {
        return this.modalDataset.id;
      } else {
        return 0;
      }
    },
    notEmpty() {
      return this.internalDatasetList && this.internalDatasetList.length > 0;
    },
    currentDataset() {
      return this.$store.state.datasets.currentDataset;
    },
    currentDatasetID() {
      return this.currentDataset ? this.currentDataset.id : 0;
    },
    internalDatasetList: {
      get() {
        return this.$store.state.datasets.datasetList;
      },
      set(value) {
        this.$store.commit('datasets/setDatasetList', value);
      },
    },
    showParked: {
      get() {
        return this.$store.state.datasets.showParked;
      },
      set(value) {
        this.$store.commit('datasets/setShowParked', value);
      },
    },
    projectList() {
      return this.$store.state.projects.projectList;
    },
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
    storeRefreshDatasetId() {
      return this.$store.state.datasets.refreshDatasetId;
    },
    isPublic() {
      return this.currentProject.is_public;
    },
    selectedDatasetsObjects() {
      if (!this.internalDatasetList) return [];
      return this.internalDatasetList.filter(d => this.selectedDatasets[d.id]);
    },
    selectedCount() {
      return Object.keys(this.selectedDatasets).length;
    },
  },
  watch: {
    async currentProject() {
      this.getProjectPermissionsForCurrentUser();
      this.getParkedDatasetsCount();
      await this.getDatasets();
      // Asynchronously get annotation set counts
      await this.getDatasetsDetails();
      const promises = this.internalDatasetList.map((d) => this.getAnnotationSetsForDataset(d).then((refreshedAnnotationSets) => {
        this.setDatasetAnnotationSets(d, refreshedAnnotationSets);
      }));
      await Promise.all(promises);
    },
    // datasetFilters() {
    //   if (this.datasetFilters.includes('showParked')) {
    //     this.showParked = true;
    //   } else {
    //     this.showParked = false;
    //   }
    // },
    async showParked() {
      this.getParkedDatasetsCount();
      await this.getDatasets();
      // Asynchronously get annotation set counts
      await this.getDatasetsDetails();
      const promises = this.internalDatasetList.map((d) => this.getAnnotationSetsForDataset(d).then((refreshedAnnotationSets) => {
        this.setDatasetAnnotationSets(d, refreshedAnnotationSets);
      }));

      await Promise.all(promises);
    },
    async storeRefreshDatasetId() {
      if (this.storeRefreshDatasetId) {
        const refreshDS = this.internalDatasetList.find((e) => e.id === this.storeRefreshDatasetId);
        if (refreshDS) {
          await this.refreshDatasetCard(refreshDS);

          this.$store.commit('datasets/setRefreshDatasetId', null);
        }
      }
    },
    selectedDatasets: {
      handler(newVal) {
        console.log('selectedDatasets changed:', newVal, 'Count:', Object.keys(newVal).length);
      },
      deep: true,
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'tasks/updateImportTaskStatus') {
        if (mutation.payload.data.status === 'complete') {
          const taskID = mutation.payload.taskID;
          if (state.tasks.importTasks[taskID].dataset_id) {
            this.refreshDatasetCard(this.getDatasetWithID(state.tasks.importTasks[taskID].dataset_id));
          }
        }
      }
      if (mutation.type === 'tasks/updateExportTaskStatus') {
        const taskID = mutation.payload.taskID;
        if (mutation.payload.data.status === 'complete') {
          if (state.tasks.exportTasks[taskID].dataset_id) {
            const dsID = state.tasks.exportTasks[taskID].dataset_id;
            this.$store.commit('notifications/updateDatasetsNotifications', {
              dataset_id: dsID,
              key: 'downloads',
              value: this.$store.state.notifications.datasets[dsID] ? this.$store.state.notifications.datasets[dsID]['downloads'] + 1 : 1,
            });
          }
        }
      }
    });
  },
  unmounted() {
    this.abortAllSignals();
  },
  beforeUnmount() {
    this.stopStatusInterval();
    this.unsubscribe();
  },
  async mounted() {
    this.getProjectPermissionsForCurrentUser();
    this.getParkedDatasetsCount();
    await this.getDatasets();
    await this.getDatasetsDetails();

    // DE-2434
    // Annotation Counts are now moved to details dialog  
    // Asynchronously get annotation set counts
    // 
    // const promises = this.internalDatasetList.map((d) => this.getAnnotationSetsForDataset(d).then((refreshedAnnotationSets) => {
    //   this.setDatasetAnnotationSets(d, refreshedAnnotationSets);
    // }));
    // await Promise.all(promises);



    this.startStatusInterval();
  },
  methods: {
    async getProjectPermissionsForCurrentUser() {
      if (this.currentProject) {
        const user = this.$store.state.user.user;
        await this.dataConnect.getProjectAccessForSingleUser({
          project_id: this.currentProject.id,
          username: user.username,
        })
          .then((data) => {
            if (data.result) {
              this.permissions = data.result;
              this.isReadOnly = !data.result['project_write'];
            }
          })
          .catch((e) => console.log(e));
      }
    },
    setDatasetAnnotationSets(d, sets) {
      const index = this.getDatasetIndex(d);
      this.$store.commit('datasets/setDatasetAnnotationSets', { index, sets });
    },
    setDatasetLabels(d, labels) {
      const index = this.getDatasetIndex(d);
      if (index >= 0) {
        const updatedDataset = {
          ...d,
          labels,
        };
        this.$store.commit('datasets/updateDataset', updatedDataset);
      }
    },
    setDataset(dataset) {
      const index = this.getDatasetIndex(dataset);
      this.$store.commit('datasets/setDataset', { index, dataset });
    },
    async getDatasetsDetails() {
      const currentProject = this.$store.state.projects.currentProject;
      if (currentProject) {
        const params = {
          project_id: currentProject.id,
          get_num_images: true,
          get_labels: true,
          get_num_labels: true,
          get_annotation_sets: true,
          get_groups: true,
          get_parked: this.showParked,
          get_docker_tasks: true,
        };

        await this.dataConnect.getDatasetList(params)
          .then((resp) => {
            if (!resp.error) {
              // const temp = resp.result;
              // const shallowDatasets = JSON.parse(JSON.stringify(this.internalDatasetList));
              // shallowDatasets.forEach((e, i) => {
              //   shallowDatasets[i].annotation_sets = temp[i].annotation_sets;
              //   shallowDatasets[i].annotation_sets?.forEach((set, j) => {
              //     shallowDatasets[i].annotation_sets[j].num_images = temp[i].annotation_sets[j] ? temp[i].annotation_sets[j].num_images : 0;
              //     shallowDatasets[i].annotation_sets[j].num_annotations = temp[i].annotation_sets[j] ? temp[i].annotation_sets[j].num_annotations : 0;
              //   });
              //   shallowDatasets[i].numImages = temp[i].numImages ? temp[i].numImages : 0;
              //   shallowDatasets[i].labels = temp[i].labels ? temp[i].labels : [];
              //   shallowDatasets[i].numLabels = temp[i].numLabels ? temp[i].numLabels : 0;
              //   shallowDatasets[i].groups = temp[i].groups ? temp[i].groups : [];
              // });

              this.internalDatasetList = resp.result;
            } else {
              throw Error(resp.error.message);
            }
          })
          .catch((error) => {
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to get details for datasets: ${error}`,
              type: "error",
              position: "top",
            });
          });
      }
    },
    async getDatasets() {
      if (this.currentProject) {
        const params = {
          project_id: this.currentProject.id,
          get_parked: this.showParked,
          get_docker_tasks: true,
        };
        this.isFetching = true;
        await this.dataConnect.getDatasetList(params)
          .then((resp) => {
            if (resp.error) {
              this.internalDatasetList = [];
              this.isFetching = false;
              throw Error(resp.error.message);
            } else {
              let temp = resp.result;
              temp = temp.map((e) => {
                e.annotation_sets = [];
                e.numImages = null;
                e.labels = null;
                e.numLabels = null;
                e.groups = null;
                return e;
              });

              this.internalDatasetList = temp;

              if (this.modalDataset) {
                const ds = this.internalDatasetList.find((e) => e.id === this.modalDataset.id);
                if (ds) {
                  this.modalDataset = ds;
                }
              }
              this.isFetching = false;
            }
          })
          .catch((error) => {
          // TODO: handle error
            this.isFetching = false;
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to get  datasets: ${error}`,
              type: "error",
              position: "top",
            });
          });
      } else {
        this.internalDatasetList = [];
      }
    },
    async getParkedDatasetsCount() {
      if (this.currentProject) {
        const params = {
          project_id: this.currentProject.id,
        };
        this.isFetchingParkedDatasetCount = true;
        await this.dataConnect.getParkedDatasetCount(params)
          .then((resp) => {
            if (resp.error !== undefined) {
              throw Error(resp.error.message);
            }
            this.parkedDatasetCount = resp.result;
          })
          .catch((error) => {
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to get parked dataset count: ${error}`,
              type: "error",
              position: "top",
            });
          });
      } else {
        this.parkedDatasetCount = null;
      }
      this.isFetchingParkedDatasetCount = false;
    },
    handleOpenAnnotationCopy(set, d) {
      this.copyAnnotationSet = set;
      this.copyAnnotationSetDataset = d;
      this.openCopyAnnSetModal();
    },
    handleSelectDataset(d) {
      this.$store.commit('datasets/setCurrentDataset', d);
    },
    openConfirmDeleteDatasetModal(d) {
      this.confirmMessage = `Are you sure you want to move dataset "${d.name}" to recycle bin?`;
      this.confirmMessageHeader = 'Remove Dataset';
      this.buttonText = "Delete";
      this.buttonClass = "button-delete";
      this.toDelete = d;
      this.confirmFunction = () => this.deleteDataset();
      this.$refs.confirmModal.showModal();
    },
    async deleteDataset() {
      const param = {
        name: this.toDelete.name,
        id: this.toDelete.id,
      };
      await this.dataConnect.deleteDataset(param)
        .then((resp) => {
          if (resp.error) {
            throw Error(resp.error.message);
          }
          const dsList = [...this.internalDatasetList];
          const toRemove = this.internalDatasetList.find((e) => e.id === this.toDelete.id);
          dsList.splice(dsList.indexOf(toRemove), 1);
          this.internalDatasetList = dsList;
        })
        .catch((err) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to move dataset to recycle bin: ${err}`,
            type: "error",
            position: "top",
          });
        });
      this.toDelete = null;
    },
    openConfirmDeleteAnnsetModal(s) {
      this.confirmMessage = `Are you sure you want to move annotation set "${s.name}" to recycle bin?`;
      this.confirmMessageHeader = 'Remove Annotation Set';
      this.buttonText = "Remove";
      this.buttonClass = "button-delete";
      this.toDelete = s;
      this.confirmFunction = () => this.deleteAnnset();
      this.$refs.confirmModal.showModal();
    },
    async deleteAnnset() {
      await this.dataConnect.deleteAnnotationSet({ annotation_set_id: this.toDelete.id })
        .then((data) => {
          if (!data.error) {
            const d = this.internalDatasetList.find((e) => e.id === this.toDelete.dataset_id);
            this.handleAnnotationSetDeletedEvent(d);

            this.toDelete = null;
          } else {
            throw Error(resp.error.message);
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to move annotation set to recycle bin: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    openConfirmDeleteGroupModal(group) {
      this.confirmMessage = `Are you sure you want to delete group with name "${group.name}"?`;
      this.confirmMessageHeader = 'Delete Group';
      this.buttonText = "Delete";
      this.buttonClass = "button-delete";
      this.toDelete = group;
      this.confirmFunction = () => this.deleteGroup();
      this.$refs.confirmModal.showModal();
    },
    async deleteGroup() {
      await this.dataConnect.deleteGroup({ group_id: this.toDelete.id })
        .then((data) => {
          if (!data.error) {
            const d = this.internalDatasetList.find((e) => e.id === this.toDelete.dataset_id);
            this.modalDataset = null;
            this.refreshDatasetCard(d);

            this.toDelete = null;
          } else {
            throw Error(data.error.message);
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to delete group: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    openCreateModal() {
      this.$refs.createDatasetModal.showModal();
    },
    openUpdateModal(d) {
      this.modalDataset = d;
      this.$refs.updateDatasetModal.showModal();
    },
    closeCreateModal() {
      this.$refs.createDatasetModal.closeModal();
    },
    closeUpdateModal() {
      this.modalDataset = null;
      this.$refs.updateDatasetModal.closeModal();
    },
    openExportModal(d) {
      this.impexDataset = d;
      this.$nextTick(() => {
        this.$refs.datasetExportModal.showModal();
      });
    },
    openUploadModal(d) {
      this.modalDataset = d;
      this.showUploadModal = true;
    },
    openSnapshotsModal(d) {
      this.modalDataset = d;
      this.showSnapshotsModal = true;
    },
    openImportAnnsetModal(d) {
      this.modalDataset = d;
      this.$refs.importAnnsetModal.showModal();
    },
    handleStartExport(d, task) {
      if (task) {
        this.$store.commit('tasks/addExportTask', {
          taskID: task.id, docker_task_id: task.id, type: task.name, dataset_id: d.id,
        });
      }
    },
    closeExportModal() {
      this.$refs.datasetExportModal.closeModal();
    },
    async updateDataset(params, d) {
      await this.dataConnect.updateDataset(params)
        .then((data) => {
          if (data.result) {
            this.refreshDatasetCard(d);
          } else if (data.error) {
            throw Error(data.error.message);
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to update dataset: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    handleCopyDatasetClicked(d) {
      this.modalDataset = d;
      this.showCopyModal = true;
    },
    async confirmCopy(args) {
      this.confirmMessage = `Destination dataset contains ${args.duplicate_count} ${args.duplicate_count === 1 ? 'image' : 'images'} with the same name. 
      ${args.duplicate_count === 1 ? 'This image' : 'These images'} will be ignored.`;
      this.confirmNote = "";
      this.confirmMessageHeader = 'Duplicate files';
      this.buttonText = "Confirm";
      this.buttonClass = "";
      this.confirmFunction = async () => { await this.handleConfirmCopy(args.fullParams); };
      this.$refs.confirmModal.showModal();
    },
    async handleConfirmCopy(params) {
      await this.dataConnect.confirmCopySequences(params)
        .then((resp) => {
          if (resp.error !== undefined) {
            throw Error(resp.error.message);
          } else if (resp.result) {
            const destDS = this.internalDatasetList.find((e) => e.id === params.dest_dataset_id);
            if (!destDS) {
              $toast.open({
                queue: true,
                duration: 5000,
                message: `Copying in progress. Refresh the page to view progress.`,
                type: "success",
                position: "top",
              });
              this.refreshDatasetCard(destDS);
            } else {
              $toast.open({
                queue: true,
                duration: 5000,
                message: `Copying in progress.`,
                type: "success",
                position: "top",
              });
            }

            this.getTasks();
            if (!this.isGettingTasks) {
              this.resumeGetTasks();
            }

            this.showCopyModal = false;
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Failed to copy: ${error.message}`,
            type: "error",
            position: "top",
          });
        });
    },
    clearCopyAnnset() {
      this.copyAnnotationSetDataset = null;
    },
    async handleCopyAnnSetCompleted() {
      await this.refreshDatasetInfo(this.copyAnnotationSetDataset);
    },
    handleCreateAnnotationSet(dataset) {
      this.modalDataset = dataset;
      this.$nextTick(() => {
        this.$refs.createAnnotationSetModal.showModal();
      });
    },
    handleUpdateAnnotationSet(dataset, annset) {
      this.modalDataset = dataset;
      this.modalAnnotationSet = annset;
      this.$nextTick(() => {
        this.$refs.updateAnnotationSetModal.showModal();
      });
    },
    async handleAnnotationSetCreatedEvent(dataset) {
      this.modalDataset = null;
      await this.refreshDatasetCard(dataset);
    },
    async handleAnnotationSetUpdatedEvent(dataset) {
      this.modalDataset = null;
      this.modalAnnotationSet = null;
      await this.refreshDatasetCard(dataset);
    },
    async handleAnnotationSetCreatedErrorEvent(error) {
      if (error.message.includes("limit reached")) {
        this.confirmMessage = `Not enough credits to perform this operation.`;
        this.confirmMessageHeader = 'Insufficient Credits';
        this.buttonText = "";
        this.$refs.confirmModal.showModal();
      }
    },
    async handleAnnotationSetDeletedEvent(dataset) {
      this.modalDataset = null;
      await this.refreshDatasetCard(dataset);
    },
    handleCreateLabel(dataset) {
      this.modalDataset = dataset;
      this.$nextTick(() => {
        this.$refs.createLabelsModal.showModal();
      });
    },
    handleUpdateLabel(dataset) {
      this.refreshLabels(dataset);
    },
    async handleLabelCreatedEvent(dataset) {
      this.modalDataset = null;
      await this.refreshDatasetCard(dataset);
    },
    async handleLabelDeletedEvent(label, dataset) {
      this.confirmMessage = `Are you sure you want to delete label '${label.name}'. All annotations with this label name will be deleted.`;
      this.confirmNote = `Only use this feature if you have no annotations with this label name, or you want to remove all annotations with this label name.`;
      this.confirmMessageHeader = 'Delete Label';
      this.buttonText = "Confirm";
      this.buttonClass = "button-delete";
      this.confirmFunction = async () => {
        await this.dataConnect.deleteLabel({ label_id: label.id })
          .then(async (data) => {
            if (data.error) {
              throw Error(data.error.message);
            }
            await this.refreshDatasetCard(dataset);
          })
          .catch((error) => {
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to delete label: ${error}`,
              type: "error",
              position: "top",
            });
          });
      };

      this.$refs.confirmModal.showModal();
    },
    async handleCopyInProgress(dataset, project) {
      if (project && project.id === this.currentProject.id) {
        if (dataset) {
          this.refreshDatasetCard(dataset);
        } else {
          this.refreshPage();
        }
      }
    },
    async refreshDatasetCard(d) {
      const newDataset = await this.refreshDatasetInfo(d);
      this.refreshAnnotationSets(newDataset);
      this.refreshLabels(newDataset);
    },
    async refreshDatasetInfo(d) {
      const newDatasetInfo = await this.getDatasetInfo(d);
      this.setDataset(newDatasetInfo);
      return newDatasetInfo;
    },
    async refreshAnnotationSets(d) {
      const refreshedAnnotationSets = await this.getAnnotationSetsForDataset(d);
      this.setDatasetAnnotationSets(d, refreshedAnnotationSets);
    },
    async refreshLabels(d) {
      const refreshedLabels = await this.getLabelListForDataset(d);
      this.setDatasetLabels(d, refreshedLabels);
    },
    openCopyAnnSetModal() {
      this.$refs.copyAnnSetModal.showModal();
    },
    async getDatasetInfo(dataset) {
      const resp = await this.dataConnect.getDatasetById({
        dataset_id: dataset.id,
        get_num_images: true,
        get_num_labels: true,
        get_num_annotations: true,
        get_annotation_sets: true,
        get_labels: true,
        get_groups: true,
        get_docker_tasks: true,
      })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to retrieve dataset: ${error}`,
            type: "error",
            position: "top",
          });
        });
      if (!resp || resp.error || !resp.result) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Failed to retrieve dataset: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        return null;
      }
      return resp.result;
    },
    async getAnnotationSetsForDataset(dataset) {
      const controller = new AbortController();
      this.controllers.push(controller);

      const resp = await this.dataConnect.getAnnotationSets({
        dataset_id: dataset.id,
        get_num_annotations: true,
        get_num_images: true,
        get_labels: true,
      }, controller.signal)
        .catch((error) => {
          console.log(error);
        });
      if (!resp || resp.error || !resp.result) {
        return [];
      }
      return resp.result;
    },
    async getLabelListForDataset(dataset) {
      const resp = await this.dataConnect.getLabelList({ dataset_id: dataset.id })
        .catch((error) => {
          if (!error.includes("AbortError")) {
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to retrieve labels: ${error}`,
              type: "error",
              position: "top",
            });
          }
        });
      if (!resp || resp.error || !resp.result) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Failed to retrieve labels: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        return [];
      }
      return resp.result;
    },
    getDatasetIndex(dataset) {
      return this.internalDatasetList.indexOf(this.internalDatasetList.find((d) => d.id === dataset.id));
    },
    getDatasetWithID(datasetID) {
      return this.internalDatasetList.find((d) => d.id === datasetID);
    },
    handleOpenDatasetAccessManagement(dataset) {
      this.modalDataset = dataset;
      this.$nextTick(() => {
        this.$refs.manageDatasetAccessModal.showModal();
      });
    },
    async handleAccessUpdated(d) {
      await this.refreshDatasetInfo(d)
        .then(() => {
          if (this.modalDataset) {
            const ds = this.internalDatasetList.find((e) => e.id === this.modalDataset.id);
            if (ds) {
              this.modalDataset = ds;
            }
          }
        });
      this.refreshAnnotationSets(d);
      this.refreshLabels(d);
    },
    async getExportList() {
      await this.dataConnect.getExportList()
        .catch((error) => {
          console.log('Failed to retrieve sets:', error);
        });
    },
    async handleCancelDockerTask(dataset, taskID) {
      await this.dataConnect.deleteDockerTask({ docker_task_id: taskID })
        .then(async (data) => {
          if (data.result) {
            await this.refreshDatasetInfo(dataset);
          }
        });
    },
    async createDataset(params) {
      this.closeCreateModal();
      const updatedParams = {
        ...params,
        project_id: this.currentProject.id,
      };
      const createDatasetResp = await this.dataConnect.createDataset(updatedParams)
        .catch((error) => {
          event('create_dataset_failure', {
            category: 'create_dataset',
            label: 'User failed to create a dataset',
            user: this.$store.state.user.user.username,
            reason: createDatasetResp.error.message,
          });
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to create dataset: ${error}`,
            type: "error",
            position: "top",
          });
        });
      if (!createDatasetResp || createDatasetResp.error || !createDatasetResp.result) {
        event('create_dataset_failure', {
          category: 'create_dataset',
          label: 'User failed to create a dataset',
          user: this.$store.state.user.user.username,
          reason: createDatasetResp.error.message,
        });
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Failed to create dataset: ${createDatasetResp.error.message}`,
          type: "error",
          position: "top",
        });
        return;
      }

      event('create_dataset_success', {
        category: 'create_dataset',
        label: 'User successfully created a dataset',
        user: this.$store.state.user.user.username,
      });

      const dsList = [...this.internalDatasetList];
      createDatasetResp.result.groups = [];
      dsList.unshift(createDatasetResp.result);
      this.internalDatasetList = dsList;

      this.refreshDatasetCard(this.internalDatasetList[0]);

      // Create owner dataset access for newly created dataset
      // await this.dataConnect.addDatasetAccess({
      //   username: this.$store.state.user.user.username,
      //   dataset_id: createDatasetResp.result.id,
      //   role: 'owner',
      // })
      //   .then(() => {
      //     const dsList = [...this.internalDatasetList];
      //     dsList.unshift(createDatasetResp.result);
      //     this.internalDatasetList = dsList;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    async handleToggleFreeze(d, isFrozen) {
      await this.dataConnect.freezeDataset({
        dataset_id: d.id,
        is_frozen: isFrozen,
      })
        .then(async (data) => {
          if (data.result) {
            await this.refreshDatasetCard(d);
          } else if (data.error) {
            throw Error(data.error.message);
          }
        }).catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to freeze dataset: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    async handleUploadError(data) {
      this.confirmMessage = data.confirmMessage;
      this.confirmMessageHeader = data.confirmMessageHeader;
      this.buttonText = "";
      this.$refs.confirmModal.showModal();
    },
    openCreateGroupsModal(d) {
      this.modalDataset = d;
      this.$refs.createGroupsModal.showModal();
    },
    async handleNavigateToGallery(d) {
      this.handleSelectDataset(d);
      await this.$nextTick();
      goto_dataset_gallery(d.id);
    },
    handleOpenGenerateTokenModal(d) {
      this.modalDataset = d;
      this.$refs.generateTokenModal.showModal();
    },
    handleOpenConfMatrix(d, set) {
      this.handleSelectDataset(d);
      this.$store.commit('datasets/setConfMatrixTargetSet', set);
      this.$refs.confusionMatrixModal.showModal();
    },

    abortAllSignals() {
      this.controllers.forEach((controller) => {
        if (!controller.signal.aborted) {
          controller.abort();
        }
      });
    },
    refreshPage() {
      this.getDatasets();
      this.getDatasetsDetails();
    },
    handleOpenAddSnapshotModal(d) {
      this.modalDataset = d;
      this.$refs.addSnapshotModal.showModal();
    },
    async startStatusInterval() {
      function sleep(time) {
        return new Promise((resolve) => {
          setTimeout(resolve, time);
        });
      }
      await sleep(5000);
      this.interval = setInterval(
        () => {
          this.internalDatasetList.forEach((dataset) => {
            if (dataset.docker_task_id && dataset.docker_task) {
              if (!dataset.docker_task.status.toLowerCase().includes('complete')
                  && !dataset.docker_task.status.toLowerCase().includes('error')
                  && !dataset.docker_task.status.toLowerCase().includes('terminate')) {
                this.refreshDatasetCard(dataset);
              }
            }
          });
        },
        5000,
      );
    },
    stopStatusInterval() {
      clearInterval(this.interval);
    },
    async dismissError(d) {
      await this.dataConnect.updateDataset({ dataset_id: d.id, remove_background_task: true })
        .then((data) => {
          if (data.result) {
            this.refreshDatasetCard(d);
          } else if (data.error) {
            throw Error(data.error.message);
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to dismiss error: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    async generateHash(d, set) {
      await this.dataConnect.GetDatasetAnnotationsHash({ dataset_id: d.id, annotation_set_id: set.id })
        .then((data) => {
          if (data.result && !data.error) {
            const annotationSets = structuredClone(toRaw(d.annotation_sets));
            const index = annotationSets.findIndex((item) => item.id === set.id);
            if (index > -1) {
              annotationSets[index].hashed_id = data.result;
              this.setDatasetAnnotationSets(d, annotationSets);
            }
          } else if (data.error) {
            $toast.open({
              queue: true,
              dismissible: true,
              message: `Failed to generate hash: ${data.error.message}`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to dismiss error dataset: ${error}`,
            type: "error",
            position: "top",
          });
        });
    },
    async confirmDuplicateUpload(args) {
      this.confirmMessage = `Destination dataset contains ${args.duplicate_count} ${args.duplicate_count === 1 ? 'image' : 'images'} with the same name. 
        These images will be ignored.`;
      this.confirmNote = "";
      this.confirmMessageHeader = 'Duplicate files';
      this.buttonText = "Confirm";
      this.buttonClass = null;
      this.confirmFunction = async () => { await this.handleConfirmDuplicateUpload(args.fullParams); };
      this.$refs.confirmModal.showModal();
    },
    async handleConfirmDuplicateUpload(params) {
      this.$refs.uploadImagesModal.handleUploadConfirmed({ ...params, ignoreDuplicate: true });
    },
    handleDatasetSelected(payload) {
      console.log('Dataset selected/deselected:', payload.id, 'Checked:', payload.checked);
      console.log('Before update, selectedDatasets:', this.selectedDatasets);
      
      if (payload.checked) {
        this.selectedDatasets[payload.id] = true;
      } else {
        delete this.selectedDatasets[payload.id];
      }
      
      console.log('After update, selectedDatasets:', this.selectedDatasets);
      console.log('Object.keys length:', Object.keys(this.selectedDatasets).length);
    },
    handleMoveSelectedDatasets() {
      if (Object.keys(this.selectedDatasets).length === 0) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: 'Please select at least one dataset to move',
          type: 'warning',
          position: 'top',
        });
        return;
      }
      this.$refs.datasetMoveDialog.openModal();
    },
    handleDeleteSelectedDatasets() {
      if (Object.keys(this.selectedDatasets).length === 0) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: 'Please select at least one dataset to delete',
          type: 'warning',
          position: 'top',
        });
        return;
      }
      this.$refs.datasetDeleteDialog.openModal();
    },
    handleDatasetsMoved(payload) {
      // Clear selections after successful move
      this.clearSelections();
      // Refresh the dataset list
      this.getDatasets();
    },
    handleDatasetsDeleted(payload) {
      // Clear selections after successful delete
      this.clearSelections();
      // Refresh the dataset list
      this.getDatasets();
    },
    handleDatasetActionClick(eventKey) {
      switch(eventKey) {
        case 'new':
          this.openCreateModal();
          break;
        case 'move':
          this.handleMoveSelectedDatasets();
          break;
        case 'park':
          this.handleParkSelectedDatasets();
          break;
        case 'unpark':
          this.handleUnparkSelectedDatasets();
          break;
        case 'delete':
          this.handleDeleteSelectedDatasets();
          break;
      }
    },
    clearSelections() {
      // Clear all selections
      Object.keys(this.selectedDatasets).forEach(id => {
        delete this.selectedDatasets[id];
      });
    },
    async handleParkSelectedDatasets() {
      if (Object.keys(this.selectedDatasets).length === 0) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: 'Please select at least one dataset to park',
          type: 'warning',
          position: 'top',
        });
        return;
      }
      const datasetIds = Object.keys(this.selectedDatasets).map(id => parseInt(id));
      
      try {
        const promises = datasetIds.map(id => 
          this.dataConnect.parkDataset({ dataset_id: id })
        );
        await Promise.all(promises);
        
        this.clearSelections();
        this.getDatasets();
        
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Successfully parked ${datasetIds.length} dataset(s)`,
          type: 'success',
          position: 'top',
        });
      } catch (error) {
        const errorMessage = error?.message || 'Error parking datasets';
        console.error('Error parking datasets:', error);
        $toast.open({
          queue: true,
          dismissible: true,
          message: errorMessage,
          type: 'error',
          position: 'top',
        });
      }
    },
    async handleUnparkSelectedDatasets() {
      if (Object.keys(this.selectedDatasets).length === 0) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: 'Please select at least one dataset to unpark',
          type: 'warning',
          position: 'top',
        });
        return;
      }
      const datasetIds = Object.keys(this.selectedDatasets).map(id => parseInt(id));
      
      try {
        const promises = datasetIds.map(id => 
          this.dataConnect.unparkDataset({ dataset_id: id })
        );
        await Promise.all(promises);
        
        this.clearSelections();
        this.getDatasets();
        
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Successfully unparked ${datasetIds.length} dataset(s)`,
          type: 'success',
          position: 'top',
        });
      } catch (error) {
        const errorMessage = error?.message || 'Error unparking datasets';
        console.error('Error unparking datasets:', error);
        $toast.open({
          queue: true,
          dismissible: true,
          message: errorMessage,
          type: 'error',
          position: 'top',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.controls {
  display: flex;
  margin: 20px 20px 0 20px;
  align-items: center;
  gap: 10px;

  &__count {
    display: flex;
    font-weight: bold;
    font-size: 1rem;
    white-space: nowrap;
  }

  &__start {
    display: flex;
    justify-content: flex-start;
    width: fit-content;
    gap: 10px;
  }

  &__end {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  &__actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    height: 100%;
  }
}

.actions-dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
}

.actions-button {
  position: relative;
  z-index: 100;
}

.actions-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 101;
  min-width: 150px;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  &.dropdown-item-danger {
    color: #ef4444;

    &:hover:not(:disabled) {
      background: #fef2f2;
    }
  }
}



:deep(.controls__skeleton-loader) {
  width: 26px;
}

:deep(.controls__skeleton-loader .v-skeleton-loader__list-item) {
  margin: 0;
}

:deep(.controls__skeleton-loader .v-skeleton-loader__list-item .v-skeleton-loader__text) {
  height: 16px;
  margin-top: 4px;
}

.manager-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(370px, 100%), 1fr));
  grid-auto-rows: 470px;
  width: 100%;
  gap: 16px;
  padding: 16px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.list-card {
  height: 100%;
  width: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.parked-toggle-btn {
  height: 26px;
}

</style>
